import angular from 'angular';

import template from './brand-statistics.html';
import './brand-statistics.less';

const brandColors = {
  'Apoquel Chews': '#ebae96',
  Apoquel: '#ffa87a',
  'Simparica Trio': '#f8ccb5',
  Simparica: '#f4ded3',
  ProHeart: '#f2e7e2',
  AlphaTRAK: '#abe3ce',
  Rimadyl: '#f8e7d0',
  'Revolution Plus': '#ffddaf',
  Revolution: '#e0dab4',
  Convenia: '#c1d6b9',
  Rovera: '#82cfc3',
  Cerenia: '#63ccc8',
  Cytopoint: '#e0d5c5',
  Paradyne: '#c5e0d7',
};

const brandNameMap = {
  ProHeart: 'ProHeart',
  'ProHeart 6': 'ProHeart',
  'ProHeart 12': 'ProHeart',
  Proheart6: 'ProHeart',
  Proheart12: 'ProHeart',
  RevolutionPlus: 'Revolution Plus',
  'Revolution Plus': 'Revolution Plus',
};

const mapStateToScope = (state) => {
  return {
    statistics: state.organization?.activeOrganization?.statistics,
  };
};

angular.module('myConsultApp').directive('brandStatistics', () => {
  return {
    template,
    restrict: 'E',
    controller: ($scope, $ngRedux) => {
      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope)($scope);
      };

      $scope.init();

      $scope.unwatch = $scope.$watch('statistics', (statistics) => {
        if (statistics) {
          const thisYear = new Date().getFullYear();
          const dataByBrand = statistics.brands?.reduce((acc, current) => {
            const { name, point_counts } = current;
            const brandName = brandNameMap[name] ?? name;
            const ytd = point_counts.find((x) => x.year === thisYear)?.point_count ?? 0;
            const all = point_counts.reduce((total, year) => total + year.point_count, 0);

            if (!acc[brandName]) {
              acc[brandName] = {
                label: brandName,
                color: brandColors[brandName],
                ytd: 0,
                all: 0,
              };
            }

            acc[brandName].all += all;
            acc[brandName].ytd += ytd;
            return acc;
          }, {});

          const dataByBrandArray = Object.values(dataByBrand);
          $scope.datasets = {
            all: dataByBrandArray.reduce(
              (acc, current) => {
                if (current.all > 0) {
                  acc.data.push(current.all);
                  acc.labels.push(current.label);
                  acc.colors.push(current.color);
                }
                return acc;
              },
              {
                data: [],
                labels: [],
                colors: [],
              },
            ),
            ytd: dataByBrandArray.reduce(
              (acc, current) => {
                if (current.all > 0) {
                  acc.data.push(current.ytd);
                  acc.labels.push(current.label);
                  acc.colors.push(current.color);
                }
                return acc;
              },
              {
                data: [],
                labels: [],
                colors: [],
              },
            ),
          };
        }
      });
      $scope.view = 'ytd';
      $scope.options = {
        legend: {
          display: true,
        },
      };

      $scope.$on('$destroy', () => {
        $scope.unwatch();
        $scope.unsubscribe();
      });
    },
  };
});
